import React from 'react'
import getText from '../strings'
import { SettingBox } from '../../application'
import CoopSE from './partners/CoopSE'
import CoopDK from './partners/CoopDK'
import Scandic from './partners/Scandic'

export default ({ partners = [], onSave }) => {
  const coopse = (partners || []).find((p) => p.partnerId.toLowerCase() === 'coopse')
  const coopdk = (partners || []).find((p) => p.partnerId.toLowerCase() === 'coopdk')
  const scandic = (partners || []).find((p) => p.partnerId.toLowerCase() === 'scandic')

  return (
    <SettingBox {...{ header: getText('partners', 'title') }}>
      <CoopSE data={coopse} onSave={onSave} />
      <CoopDK data={coopdk} onSave={onSave} />
      <Scandic data={scandic} onSave={onSave} />
    </SettingBox>
  )
}
